export class GamePickBonusEvents {
    public static readonly PICK_BONUS_FINISHED: symbol = Symbol('PICK_BONUS_FINISHED');
    public static readonly STARTED: symbol = Symbol('STARTED');
    public static readonly FINISHED: symbol = Symbol('FINISHED');
}
